import React, { useState, useEffect } from 'react';
import { 
  FaArrowLeft, 
  FaCamera, 
  FaTimes, 
  FaReceipt, 
  FaSpinner, 
  FaUpload, 
  FaCheck, 
  FaFileImage, 
  FaCommentDollar,
  FaUserCircle,
  FaRegClock,
  FaCoins,
  FaClipboardCheck
} from 'react-icons/fa';
import BottomNavigation from './BottomNavigation';
import { useAuth } from '../security/security/AuthContext';
import axios from 'axios';

const Proof = () => {
  const [currentView, setCurrentView] = useState('main');
  const [description, setDescription] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [proofs, setProofs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userDetails, token, updateUserDetails } = useAuth();
  const [toastNotification, setToastNotification] = useState(null);

  // Styles
  const styles = {
    container: {
      backgroundColor: '#0F172A',
      color: '#E2E8F0',
      minHeight: '100vh',
      paddingBottom: '80px',
      fontFamily: 'Inter, system-ui, sans-serif',
    },
    header: {
      background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
      padding: '16px',
      borderBottom: '1px solid #1E3A5F',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: '400',
      color: '#94A3B8',
      marginTop: '4px',
    },
    content: {
      padding: '16px',
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '40px 16px',
    },
    emptyIcon: {
      fontSize: '64px',
      color: '#334155',
      marginBottom: '16px',
    },
    emptyTitle: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#E2E8F0',
      marginBottom: '8px',
    },
    emptyText: {
      fontSize: '14px',
      color: '#94A3B8',
      marginBottom: '24px',
      maxWidth: '300px',
    },
    actionButton: {
      backgroundColor: '#2563EB',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    floatingActionButton: {
      position: 'fixed',
      bottom: '90px',
      right: '20px',
      backgroundColor: '#2563EB',
      color: 'white',
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 12px rgba(37, 99, 235, 0.5)',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      zIndex: 10,
      transition: 'transform 0.2s ease',
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 0',
      color: '#94A3B8',
    },
    spinner: {
      border: '4px solid #1E293B',
      borderTop: '4px solid #38BDF8',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      animation: 'spin 1s linear infinite',
      marginBottom: '16px',
    },
    proofsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '16px',
      marginBottom: '16px',
    },
    proofCard: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      border: '1px solid #334155',
      transition: 'transform 0.2s ease',
    },
    proofImageContainer: {
      width: '100%',
      height: '200px',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: '#0F172A',
    },
    proofImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    proofVerified: {
      position: 'absolute',
      top: '12px',
      right: '12px',
      backgroundColor: 'rgba(16, 185, 129, 0.8)',
      color: 'white',
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    proofDetails: {
      padding: '16px',
    },
    proofDescription: {
      fontSize: '14px',
      marginBottom: '12px',
      color: '#E2E8F0',
      borderLeft: '3px solid #2563EB',
      paddingLeft: '8px',
    },
    proofMeta: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#94A3B8',
      fontSize: '12px',
    },
    proofUserInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#E2E8F0',
      fontSize: '14px',
      cursor: 'pointer',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    label: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#E2E8F0',
    },
    input: {
      backgroundColor: '#1E293B',
      border: '1px solid #334155',
      borderRadius: '8px',
      padding: '12px 16px',
      fontSize: '14px',
      color: '#E2E8F0',
      width: '100%',
    },
    textarea: {
      backgroundColor: '#1E293B',
      border: '1px solid #334155',
      borderRadius: '8px',
      padding: '12px 16px',
      fontSize: '14px',
      color: '#E2E8F0',
      width: '100%',
      resize: 'vertical',
      minHeight: '100px',
    },
    uploadArea: {
      border: '2px dashed #334155',
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      backgroundColor: '#0F172A',
      transition: 'border-color 0.2s ease',
      minHeight: '200px',
    },
    uploadAreaActive: {
      borderColor: '#2563EB',
      backgroundColor: 'rgba(37, 99, 235, 0.1)',
    },
    uploadIcon: {
      fontSize: '32px',
      color: '#64748B',
      marginBottom: '12px',
    },
    uploadText: {
      color: '#94A3B8',
      textAlign: 'center',
    },
    uploadHint: {
      fontSize: '12px',
      color: '#64748B',
      marginTop: '8px',
      textAlign: 'center',
    },
    imagePreview: {
      position: 'relative',
      width: '100%',
      minHeight: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '8px',
      overflow: 'hidden',
      backgroundColor: '#0F172A',
    },
    previewImage: {
      maxWidth: '100%',
      maxHeight: '300px',
      objectFit: 'contain',
    },
    removeImage: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      backgroundColor: 'rgba(239, 68, 68, 0.9)',
      color: 'white',
      width: '28px',
      height: '28px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      cursor: 'pointer',
      zIndex: 10,
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
    },
    submitButton: {
      backgroundColor: '#2563EB',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '14px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    disabledButton: {
      backgroundColor: '#475569',
      cursor: 'not-allowed',
    },
    formCard: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '16px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      border: '1px solid #334155',
    },
    formCardTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#E2E8F0',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    toast: {
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#1E293B',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1001,
      width: '90%',
      maxWidth: '400px',
      border: '1px solid',
    },
    successToast: {
      borderColor: '#10B981',
    },
    errorToast: {
      borderColor: '#EF4444',
    },
  };

  const refreshUserData = async () => {
    try {
      setLoading(true);
      const userResponse = await axios.get(`https://api.novasoftwaves.com/api/v1/auth/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      updateUserDetails(userResponse.data);
      setLoading(false);
    } catch (error) {
      console.error('Error refreshing user data:', error);
      setToastNotification({ message: 'Failed to refresh user data', type: 'error' });
      setLoading(false);
    }
  };

  const fetchProofs = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://api.novasoftwaves.com/api/proofs/approved');
      // Sort the proofs in descending order by ID before setting state
      const sortedProofs = response.data.sort((a, b) => b.id - a.id);
      setProofs(sortedProofs);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching proofs:', error);
      setToastNotification({
        message: 'Failed to fetch withdrawal proofs. Please try again.',
        type: 'error'
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    // Refresh user data when component mounts
    refreshUserData();
    fetchProofs();
  }, []);

  useEffect(() => {
    if (currentView === 'main') {
      refreshUserData();
    }
  }, [currentView]);

  const handleImageSelect = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedImage) {
      setToastNotification({
        message: 'Please select a withdrawal screenshot to upload',
        type: 'error'
      });
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('image', selectedImage);
    formData.append('description', description);
    formData.append('phoneNumber', phoneNumber);
    formData.append('userEmail', userDetails.email);

    try {
      await axios.post('https://api.novasoftwaves.com/api/proofs/add', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setToastNotification({
        message: 'Withdrawal proof submitted successfully! It will be reviewed shortly.',
        type: 'success'
      });
      setCurrentView('main');
      setDescription('');
      setPhoneNumber('');
      setSelectedImage(null);
      fetchProofs();
    } catch (error) {
      console.error('Error submitting proof:', error);
      setToastNotification({
        message: 'Failed to submit withdrawal proof. Please try again.',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const ProofItem = ({ proof }) => (
    <div style={styles.proofCard}>
      <div style={styles.proofImageContainer}>
        <img 
          src={`https://api.novasoftwaves.com${proof.imageUrl}`} 
          alt="Withdrawal Proof" 
          style={styles.proofImage} 
        />
        <div style={styles.proofVerified}>
          <FaCheck size={12} /> Verified
        </div>
      </div>
      <div style={styles.proofDetails}>
        <p style={styles.proofDescription}>{proof.description}</p>
        <div style={styles.proofMeta}>
          <div style={styles.proofUserInfo}>
            <FaUserCircle size={14} />
            {proof.phoneNumber.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2')}
          </div>
          <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
            <FaRegClock size={12} />
            {new Date(proof.createdAt).toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  );

  const EmptyState = () => (
    <div style={styles.emptyState}>
      <FaFileImage style={styles.emptyIcon} />
      <h3 style={styles.emptyTitle}>No Withdrawal Proofs Yet</h3>
      <p style={styles.emptyText}>
        Be the first to share your successful withdrawal screenshot and inspire others!
      </p>
      <button 
        style={styles.actionButton}
        onClick={() => setCurrentView('share')}
      >
        <FaUpload /> Share Withdrawal Proof
      </button>
    </div>
  );

  const renderMainView = () => (
    <>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>
            <FaClipboardCheck /> Withdrawal Proofs
          </h1>
          <p style={styles.subtitle}>
            See successful transaction screenshots from our community
          </p>
        </div>
      </div>
      
      <div style={styles.content}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.spinner}></div>
            <p>Loading proofs...</p>
          </div>
        ) : (
          <>
            {proofs.length > 0 ? (
              <div style={styles.proofsGrid}>
                {proofs.map(proof => (
                  <ProofItem key={proof.id} proof={proof} />
                ))}
              </div>
            ) : (
              <EmptyState />
            )}
          </>
        )}
      </div>
      
      {proofs.length > 0 && (
        <button 
          style={styles.floatingActionButton}
          onClick={() => setCurrentView('share')}
        >
          <FaUpload />
        </button>
      )}
    </>
  );

  const renderShareProofView = () => (
    <>
      <div style={styles.header}>
        <button 
          style={styles.backButton}
          onClick={() => setCurrentView('main')}
        >
          <FaArrowLeft /> Back
        </button>
        <h1 style={styles.title}>Share Your Success</h1>
      </div>
      
      <div style={styles.content}>
        <div style={styles.formCard}>
          <h2 style={styles.formCardTitle}>
            <FaCoins /> Submit Withdrawal Proof
          </h2>
          
          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="description">Your Experience</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Share details about your successful withdrawal experience..."
                style={styles.textarea}
                required
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="phoneNumber">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Enter your phone number"
                style={styles.input}
                required
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Upload Screenshot</label>
              <input
                type="file"
                id="proofImage"
                accept="image/*"
                onChange={handleImageSelect}
                style={{ display: 'none' }}
                required
              />
              
              {selectedImage ? (
                <div style={styles.imagePreview}>
                  <img 
                    src={URL.createObjectURL(selectedImage)} 
                    alt="Selected" 
                    style={styles.previewImage}
                  />
                  <button 
                    type="button" 
                    style={styles.removeImage}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedImage(null);
                    }}
                  >
                    <FaTimes size={14} />
                  </button>
                </div>
              ) : (
                <label htmlFor="proofImage" style={{...styles.uploadArea, ...(selectedImage ? styles.uploadAreaActive : {})}}>
                  <FaCamera style={styles.uploadIcon} />
                  <p style={styles.uploadText}>Click to upload screenshot</p>
                  <p style={styles.uploadHint}>PNG, JPG or JPEG (max 5MB)</p>
                </label>
              )}
            </div>
            
            <button 
              type="submit" 
              style={{
                ...styles.submitButton, 
                ...(loading ? styles.disabledButton : {})
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <FaSpinner className="spinner" /> Submitting...
                </>
              ) : (
                <>
                  <FaUpload /> Submit Withdrawal Proof
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );

  return (
    <div style={styles.container}>
      {currentView === 'main' ? renderMainView() : renderShareProofView()}
      <BottomNavigation />
      {toastNotification && (
        <div style={{
          ...styles.toast,
          ...(toastNotification.type === 'success' ? styles.successToast : styles.errorToast)
        }}>
          {toastNotification.type === 'success' ? (
            <FaCheck color="#10B981" />
          ) : (
            <FaTimes color="#EF4444" />
          )}
          <div>{toastNotification.message}</div>
        </div>
      )}
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .spinner {
          animation: spin 1s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Proof;